import { useEffect, useRef } from "react";
import { useBlocker, useLocation } from "react-router-dom";

type UseScrollRestoreProps = {
  divRef: React.RefObject<HTMLDivElement | null>;
};

export const useScrollRestore = ({ divRef }: UseScrollRestoreProps) => {
  const location = useLocation();
  const scrollPositionsRef = useRef<Record<string, number>>({});

  useBlocker(({ currentLocation }) => {
    const node = divRef.current;
    if (node && scrollPositionsRef.current) {
      // Save scroll position of previous location
      scrollPositionsRef.current[currentLocation.pathname] = node.scrollTop;
    }
    return false;
  });

  useEffect(() => {
    if (divRef.current && scrollPositionsRef.current) {
      const savedScrollPosition = scrollPositionsRef.current[location.pathname];
      if (savedScrollPosition !== undefined) {
        // Use setTimeout to delay scroll restoration
        setTimeout(() => {
          if (divRef.current) {
            divRef.current.scrollTop = savedScrollPosition;
          }
        }, 10); // Adjust this delay as needed
      }
    }
  }, [location.pathname]);
};
